import { Loader2 } from 'lucide-react';
import { cn } from '@/lib/cn';

export function Spinner({ className }: { className?: string }) {
  return <Loader2 aria-hidden className={cn('w-4 h-4 animate-spin', className)} />;
}

/** Centered loading row for pages and lists. */
export function LoadingState({ label = 'Loading...' }: { label?: string }) {
  return (
    <div role="status" className="py-12 flex items-center justify-center gap-2 text-xs font-semibold text-slate-500">
      <Spinner className="text-blue-600" /> {label}
    </div>
  );
}
